export default __webpack_public_path__ + "static/media/KOD0028-min.8ec4e053.webp";